













































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { storeNihssAssessment } from "@/store/modules/NihssAssessmentStore";
import NihssAssessmentSvc from "@/services/NihssAssessment";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus, slotTandaTanganDokumen } from "@/utils/hapusSetelahTtd";

@Component({
  components: {
    CardModalTtd
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardNihssAssessment extends Vue {
  @Prop() register!: string;
  @Prop({ default: null }) rm!: string;
  @Prop({ default: false }) isActive!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  showForm = false;
  showDetail = false;
  isEditing = false;
  editingId: number | null = null;
  saving = false;
  formValid = false;
  dateMenu = false;
  detailData: any = null;
  modalTtd = false;
  loaded = false;

  formTanggal: string | null = null;
  formWaktu: string | null = null;

  form: any = this.getEmptyForm();

  headers = [
    { text: "No", value: "no", width: "5%", sortable: false },
    { text: "Tanggal Pemeriksaan", value: "examined_at", width: "25%" },
    { text: "Total Skor", value: "total_score", width: "15%" },
    { text: "Kesimpulan", value: "kesimpulan", width: "20%" },
    { text: "Status", value: "status", width: "10%" },
    { text: "Aksi", value: "aksi", sortable: false, width: "25%" }
  ];

  get loading() { return storeNihssAssessment.loading; }
  get stateList() { return storeNihssAssessment.list; }
  get hasUnsignedRecords() {
    return this.stateList.some(item => !item.signed_dokter);
  }

  get computedTotalScore(): number | null {
    const fields = [
      'kesadaran', 'menjawab_pertanyaan', 'mengikuti_perintah',
      'gaze', 'visual', 'paresis_wajah',
      'motorik_lengan_kiri', 'motorik_lengan_kanan',
      'motorik_tungkai', 'ataksia', 'sensorik',
      'bahasa', 'disartria', 'neglect'
    ];
    const values = fields
      .map(f => this.form[f])
      .filter(v => v !== null && v !== undefined);
    if (values.length === 0) return null;
    return values.reduce((a, b) => a + b, 0);
  }

  get computedKesimpulan(): string {
    const s = this.computedTotalScore;
    if (s === null) return '-';
    if (s >= 25) return 'Stroke Sangat Berat';
    if (s >= 15) return 'Stroke Berat';
    if (s >= 5) return 'Stroke Sedang';
    if (s >= 1) return 'Stroke Ringan';
    return 'Normal';
  }

  get alertType(): string {
    const s = this.computedTotalScore;
    if (s === null) return 'info';
    if (s >= 15) return 'error';
    if (s >= 5) return 'warning';
    return 'success';
  }

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val && !this.loaded) {
      this.loadData();
    }
  }

  mounted() {
    if (this.isActive || this.register) {
      this.loadData();
    }
  }

  async loadData() {
    if (!this.register) return;
    await storeNihssAssessment.getByRegister(this.register);
    this.loaded = true;
  }

  getEmptyForm() {
    return {
      register_id: null,
      pasien_rm: null,
      kesadaran: null,
      menjawab_pertanyaan: null,
      mengikuti_perintah: null,
      gaze: null,
      visual: null,
      paresis_wajah: null,
      motorik_lengan_kiri: null,
      motorik_lengan_kanan: null,
      motorik_tungkai: null,
      ataksia: null,
      sensorik: null,
      bahasa: null,
      disartria: null,
      neglect: null,
    };
  }

  getKesimpulanColor(kesimpulan: string | null): string {
    if (!kesimpulan) return 'grey';
    if (kesimpulan === 'Sangat Berat') return 'red darken-3';
    if (kesimpulan === 'Berat') return 'red';
    if (kesimpulan === 'Sedang') return 'orange';
    if (kesimpulan === 'Ringan') return 'green';
    return 'blue';
  }

  getAlertType(kesimpulan: string | null): string {
    if (!kesimpulan) return 'info';
    if (kesimpulan === 'Sangat Berat' || kesimpulan === 'Berat') return 'error';
    if (kesimpulan === 'Sedang') return 'warning';
    return 'success';
  }

  formatDateTime(dt: string | null): string {
    if (!dt) return '-';
    try {
      const d = new Date(dt);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      const hours = String(d.getHours()).padStart(2, '0');
      const mins = String(d.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${mins}`;
    } catch {
      return dt;
    }
  }

  openForm() {
    this.form = this.getEmptyForm();
    this.formTanggal = null;
    this.formWaktu = null;
    this.isEditing = false;
    this.editingId = null;
    this.showForm = true;
  }

  openEdit(item: any) {
    this.form = { ...item };
    // Parse examined_at into separate date and time
    if (item.examined_at) {
      const d = new Date(item.examined_at);
      this.formTanggal = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      this.formWaktu = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    } else {
      this.formTanggal = null;
      this.formWaktu = null;
    }
    this.isEditing = true;
    this.editingId = item.id;
    this.showForm = true;
  }

  async openDetail(item: any) {
    try {
      const resp = await NihssAssessmentSvc.find(item.id);
      this.detailData = resp.data.data;
      this.showDetail = true;
    } catch {
      // Error handled by service
    }
  }

  closeForm() {
    this.showForm = false;
    this.form = this.getEmptyForm();
    this.formTanggal = null;
    this.formWaktu = null;
  }

  async simpan() {
    if (!(this.$refs.formRef as any).validate()) return;

    // Combine date + time into examined_at
    if (this.formTanggal) {
      const time = this.formWaktu || '00:00';
      this.form.examined_at = `${this.formTanggal} ${time}:00`;
    } else {
      this.form.examined_at = null;
    }

    this.saving = true;
    try {
      if (this.isEditing && this.editingId) {
        await NihssAssessmentSvc.update(this.editingId, this.form);
      } else {
        this.form.register_id = this.register;
        this.form.pasien_rm = this.rm;
        await NihssAssessmentSvc.create(this.form);
      }
      await storeNihssAssessment.getByRegister(this.register);
      this.closeForm();
      this.$emit("saved");
    } catch {
      // Error handled by service
    }
    this.saving = false;
  }

  alasanTidakBisaHapus(item: any): string {
    if (this.readOnly) return "Rekam medis sudah terkunci (read-only)";
    return alasanTtdMengunciHapus(
      item.user_id,
      slotTandaTanganDokumen(item.signed_dokter, item.signature_dokter),
      userModule.user?.id
    );
  }

  async remove(item: any) {
    if (this.alasanTidakBisaHapus(item)) return;
    if (!confirm("Apakah Anda yakin ingin menghapus data penilaian NIHSS ini?")) return;
    try {
      await NihssAssessmentSvc.destroy(item.id);
      await storeNihssAssessment.getByRegister(this.register);
    } catch {
      // Error handled by service
    }
  }

  cetakPdf() {
    NihssAssessmentSvc.print(this.register);
  }

  openTtd() {
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    this.modalTtd = false;

    try {
      await NihssAssessmentSvc.signByRegister(this.register, { password });
      await storeNihssAssessment.getByRegister(this.register);
    } catch {
      // Error handled by service
    }
  }
}
